import { Typography } from '@uni-of-exeter/digital.lib.react.ui.kit';

type ResourceTableColumnHeaderText = {
    headerText?: string;
}

export interface ResourceTableColumnHeaderProps  {
    text: ResourceTableColumnHeaderText;
}

export const ResourceTableColumnHeader = ({text}: ResourceTableColumnHeaderProps) => {
    return (
        <th scope="col"
            className="resourceTableHeader"
            aria-sort="none"  
        >   
            <Typography 
            variant="body"
            className="resourceTableHeaderText"
            >
                {text.headerText}
            </Typography>
        </th>
    );
};